import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFCONUSWideByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFWideFormatByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        totalPrinterQuantity: '$..TotalPrinterQuantity',
        totalPrinterPrice: '$..TotalPrinterPrice',
        totalScannerQuantity: '$..TotalScannerQuantity',
        totalScannerPrice: '$..TotalScannerPrice',
        totalInkQuantity: '$..TotalInkQuantity',
        totalInkPrice: '$..TotalInkPrice',
        totalOrderQuantity: '$..TotalOrderQuantity',
        totalOrderPrice: '$..TotalOrderPrice',
        dateEquipmentReq: '$..DateEquipmentReq',
        hasBaseAccessReq: '$..HasBaseAccessReq',
        baseAccessReqNotes: '$..BaseAccessReqNotes',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
